import { render } from "./cookie-management.vue?vue&type=template&id=5265e40a&scoped=true"
import script from "./cookie-management.vue?vue&type=script&lang=js"
export * from "./cookie-management.vue?vue&type=script&lang=js"

import "./cookie-management.vue?vue&type=style&index=0&id=5265e40a&scoped=true&lang=css"

import exportComponent from "/Users/alexey/Projects/gambody-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5265e40a"]])

export default __exports__